import { LOGO_URL } from "@/lib/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-hairline">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-5">
            <img
              src={LOGO_URL}
              alt="KP Capital crest"
              data-testid="footer-crest"
              className="w-28 h-28 object-contain"
            />
            <div className="mt-6 font-serif text-2xl tracking-[0.18em] text-bone">
              KP&nbsp;·&nbsp;CAPITAL
            </div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-smoke mt-2">
              Private Trading Society
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">Navigate</div>
            <ul className="space-y-3 font-sans text-sand">
              <li><a href="#approach" className="link-underline">Approach</a></li>
              <li><a href="#about" className="link-underline">About KP</a></li>
              <li><a href="#testimonials" className="link-underline">Mentees</a></li>
              <li><a href="#insights" className="link-underline">Insights</a></li>
              <li><a href="#faq" className="link-underline">FAQ</a></li>
              <li><a href="#apply" className="link-underline">Apply</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-5">Principles</div>
            <p className="font-serif text-xl leading-snug text-bone">
              No signals. No groups. No theatre.
              <br />
              <span className="italic font-light text-platinum">Only the work.</span>
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-hairline flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] tracking-[0.2em] uppercase text-smoke">
          <div>© {year} KP Capital — Private Trading Society. All rights reserved.</div>
          <div className="text-smoke/70">
            Trading involves substantial risk. Mentorship is educational and not financial advice.
          </div>
        </div>
      </div>
    </footer>
  );
}
